
import { Component, Vue } from 'vue-property-decorator';
import { MutationPayload } from 'vuex';
import store from '@/store';
import router from '@/router';
import Input from '@/components/form/input.vue';
import Offcanvas from '@/components/offcanvas.vue';
import { addPlan } from '@/api/plans';

interface IPlan {
  name: string;
  app_annual_event_limit: number;
  app_annual_attendee_limit: number;
  app_annual_event_manager_limit: number;
  app_annual_exhibitor_limit: number;
  one_time_price_eur: number;
  beamian_accounts_service: true,
  
  // default data
  check_in_app_service: boolean,
  custom_plan: boolean,
  check_in_max_capacity: number,
  check_in_max_events: number,
  check_in_max_event_managers: number,
  annual_price_eur: number,
  monthly_price_eur: number,
  one_time_price_usd: number,
  annual_price_usd: number,
  monthly_price_usd: number,
}

@Component({
  name: 'AddPlan',
  components: { Offcanvas, Input }
})
class AddPlan extends Vue {
  public offcanvas = {
    active: true,
    closable: true
  };

  public form = {
    name: {
      label: 'Name',
      placeholder: 'Enter plan name',
      type: 'text',
      required: true
    },
    app_annual_event_limit: {
      label: 'Events Limit',
      placeholder: 'Enter events limit',
      type: 'number',
      required: true,
      min: 0,
      step: 1
    },
    app_annual_attendee_limit: {
      label: 'Attendee Limit',
      placeholder: 'Enter attendee limit',
      type: 'number',
      required: true,
      min: 0,
      step: 1
    },
    app_annual_event_manager_limit: {
      label: 'Event Manager Limit',
      placeholder: 'Enter event manager limit',
      type: 'number',
      required: true,
      min: 0,
      step: 1
    },
    app_annual_exhibitor_limit: {
      label: 'Exhibitor Limit',
      placeholder: 'Enter exhibitor limit',
      type: 'number',
      required: true,
      min: 0,
      step: 1
    },
    one_time_price_eur: {
      label: 'Price (EUR)',
      placeholder: 'Enter price in EUR',
      type: 'number',
      required: true,
      min: 0,
      step: 1
    }
  };

  public plan: IPlan = {
    name: '',
    app_annual_event_limit: 10,
    app_annual_attendee_limit: 50000,
    app_annual_event_manager_limit: 30,
    app_annual_exhibitor_limit: 20,
    one_time_price_eur: 3000,

    // default data
    beamian_accounts_service: true,
    check_in_app_service: false,
    custom_plan: true,
    check_in_max_capacity: 0,
    check_in_max_events: 0,
    check_in_max_event_managers: 0,
    annual_price_eur: 0,
    monthly_price_eur: 0,
    one_time_price_usd: 0,
    annual_price_usd: 0,
    monthly_price_usd: 0,
  };

  public addPlanPopup: any = {
    active: false,
    title: '',
    message: '',
    type: '',
    data: null
  };

  public submit() {
    addPlan(this.plan).then((response) => {
      this.$emit('created', response.data);
    });
  }

  public discard() {
    router.push('/plans');
  }
}

export default AddPlan;
